import { useEffect, useState } from 'react'
import axios from '../../../plugins/axios'

import { useTranslation } from 'react-i18next';
import Toast from "../../../plugins/useToast";

import Dropdown from './Dropdown'

const Preference = () => {
    const { t } = useTranslation();
    const [language, setLanguage] = useState('en')
    const [nibpUnit, setNibpUnit] = useState({ label: 'mmHg', value: 'mmHg' })
    const [ibpUnit, setIbpUnit] = useState({ label: 'mmHg', value: 'mmHg' })
    const [co2Unit, setCo2Unit] = useState({ label: '%', value: '%' })
    const [tempUnit, setTempUnit] = useState({ label: '°C', value: '°C' })
    const [gasUnit, setGasUnit] = useState({ label: 'vol%', value: 'vol%' })
    const [heightUnit, setHeightUnit] = useState({ label: 'cm', value: 'cm' })
    const [weightUnit, setWeightUnit] = useState({ label: 'kg', value: 'kg' })
    const [parameterIds, setParameterIds] = useState({
        nibp: '',
        ibp: '',
        co2: '',
        temp: '',
        gas: '',
        height: '',
        weight: ''
    })
    const [dropdownStates, setDropdownStates] = useState({
        nibpUnit: false,
        ibpUnit: false,
        co2Unit: false,
        tempUnit: false,
        gasUnit: false,
        heightUnit: false,
        weightUnit: false,
    });

    const langOptions = [
        { value: 'ko', label: '한국어' },
        { value: 'en', label: 'English' },
        { value: 'it', label: 'Italiano' },
        { value: 'pl', label: 'Polski' },
    ]

    const nibpUnitArr = [
        { label: 'mmHg', value: 'mmHg' }, { label: 'kPa', value: 'kPa' }
    ]
    const ibpUnitArr = [
        { label: 'mmHg', value: 'mmHg' }, { label: 'kPa', value: 'kPa' }
    ]
    const co2UnitArr = [
        { label: 'mmHg', value: 'mmHg' }, { label: '%', value: '%' }, { label: 'kPa', value: 'kPa' }
    ]
    const tempUnitArr = [
        { label: '°C', value: '°C' }, { label: '°F', value: '°F' }
    ]
    const gasUnitArr = [
        { label: 'mmHg', value: 'mmHg' }, { label: 'kPa', value: 'kPa' }, { label: 'vol%', value: 'vol%' }
    ]
    const heightUnitArr = [
        { label: 'cm', value: 'cm' }, { label: 'in', value: 'in' }
    ]
    const weightUnitArr = [
        { label: 'kg', value: 'kg' }, { label: 'lb', value: 'lb' }
    ]

    const handleClickDropdown = (type, val) => {
        setDropdownStates(prev => ({
          ...prev,
          [type]: typeof val !== 'undefined' ? false : !prev[type],
        }));
    };

    const getData = async () => {
        try {
            const langRes = await axios.get('/system/languages');
            if (langRes.code != '200') throw langRes

            const defaultLang = langRes.data.find(lang => lang.defaultLanguage);
            if (defaultLang) {
                setLanguage(defaultLang.code);
            } else {
                setLanguage('en');
            }

            const unitRes = await axios.get('/system/measure/parameter/categories/unit')
            if (unitRes.code != '200') throw unitRes
            const unitInfo = unitRes.data.categories
            const nibpInfo = unitInfo.find(unit => unit.name === 'NIBP');
            setNibpUnit({ label: nibpInfo.defaultUnit, value: nibpInfo.defaultUnit });
            const ibpInfo = unitInfo.find(unit => unit.name === 'IBP');
            setIbpUnit({ label: ibpInfo.defaultUnit, value: ibpInfo.defaultUnit });
            const co2Info = unitInfo.find(unit => unit.name === 'CO2');
            setCo2Unit({ label: co2Info.defaultUnit, value: co2Info.defaultUnit });
            const tempInfo = unitInfo.find(unit => unit.name === 'TEMP');
            setTempUnit({ label: tempInfo.defaultUnit, value: tempInfo.defaultUnit });
            const gasInfo = unitInfo.find(unit => unit.name === 'GAS');
            setGasUnit({ label: gasInfo.defaultUnit, value: gasInfo.defaultUnit });
            setParameterIds({
                ...parameterIds,
                nibp: nibpInfo.id,
                ibp: ibpInfo.id,
                co2: co2Info.id,
                temp: tempInfo.id,
                gas: gasInfo.id,
            });

            const patientInfoRes = await axios.get('/system/patient/unit/default')
            if (patientInfoRes.code != '200') throw patientInfoRes
            const patientInfo = patientInfoRes.data;
            setWeightUnit({ label: patientInfo.weightUnit, value: patientInfo.weightUnit });
            setHeightUnit({ label: patientInfo.heightUnit, value: patientInfo.heightUnit });

        } catch (error) {
            console.error('Error fetching preference data:', error);
        }
    };

    const saveData = async () => {
        try {
            const langRes = await axios.put(`/system/languages/default`, { code: language })
            if (langRes.code != '200') throw langRes
            const unitData = [
                { id: parameterIds.nibp, unit: nibpUnit.value },
                { id: parameterIds.ibp, unit: ibpUnit.value },
                { id: parameterIds.co2, unit: co2Unit.value },
                { id: parameterIds.temp, unit: tempUnit.value },
                { id: parameterIds.gas, unit: gasUnit.value },
            ]
            const unitRes = await axios.put(`/system/measure/parameter/categories/unit/default`, { categories: unitData })
            if (unitRes.code != '200') throw unitRes

            const PatientInfo_payload = {
                "weightUnit": weightUnit.value,
                "heightUnit": heightUnit.value
            }
            const patientInfoRes = await axios.put(`/system/patient/unit/default`, PatientInfo_payload)
            if (patientInfoRes.code != '200') throw patientInfoRes

            Toast({ isSuccess: true, msg: t('admin.Preferences.SettingsSaved') })
        } catch (error) {
            console.error('Error saving preference data:', error);
            Toast({ isSuccess: false, msg: t('admin.Preferences.SettingsSaveFailed') })
        }
    }

    useEffect(() => {
        getData()
        return () => {
        };
    }, []);

    return (
        <div className="">
            <div className="flex mb-10">
                <div className="">
                    <div className="admin-title">{t('admin.Preferences.Title')}</div>
                    <div className="text-[#ABAEB2]">{t('admin.Preferences.SubTitle')}</div>
                </div>
                <div className="admin-normal-btn save ml-auto w-[100px] text-white" onClick={() => { saveData() }}>{t('admin.Preferences.Save')}</div>
            </div>
            <div className="flex gap-10">
                <div className="">
                    <div className="font-light text-[#E1E4E5] mb-3">{t('admin.Preferences.LanguageSettings')}</div>
                    <div className="bg-[#323238] p-5 rounded-lg w-[240px] h-[212px] flex flex-col text-white">
                        <div className="text-[#CBCED1] mb-5" style={{ fontSize: 18 }}>{t('admin.Preferences.Language')}</div>
                        {
                            langOptions.map((option) => (
                                <label key={`lang-option-${option.value}`} className="custom-radio mb-3">
                                    <input
                                        type="radio"
                                        checked={language === option.value}
                                        onChange={() => setLanguage(option.value)}
                                    />
                                    <span className="font-light" style={{ paddingLeft: 32, fontSize: 16 }}>{option.label}</span>
                                </label>
                            ))
                        }
                    </div>
                </div>
                <div className="" style={{ border: '1px solid var(--Cool-Neutral-Gray_14, #202024)', boxShadow: '-1px 0px 0px 0px #00000066' }} />
                <div className="">
                    <div className="font-light text-[#E1E4E5] mb-3">{t('admin.Preferences.UnitSettings')}</div>
                    <div className="flex gap-5">
                        <div className="bg-[#323238] p-5 rounded-lg w-[240px] h-[409px] flex flex-col text-white">
                            <div className="text-[#CBCED1] mb-5" style={{ fontSize: 18 }}>{t('admin.Preferences.UnitSettings')}</div>
                            <div className="font-light mb-1 text-[#E1E4E5]">NIBP</div>
                            <Dropdown 
                                type={'nibp-unit'}
                                isShow={dropdownStates.nibpUnit}
                                value={nibpUnit}
                                valueArr={nibpUnitArr}
                                handleClick={(val) => { handleClickDropdown('nibpUnit', val) }}
                                handleValueClick={(val) => { setNibpUnit(val) }}
                            />
                            <div className="font-light mb-1 text-[#E1E4E5] mt-4">IBP</div>
                            <Dropdown 
                                type={'ibp-unit'}
                                isShow={dropdownStates.ibpUnit}
                                value={ibpUnit}
                                valueArr={ibpUnitArr}
                                handleClick={(val) => { handleClickDropdown('ibpUnit', val) }}
                                handleValueClick={(val) => { setIbpUnit(val) }}
                            />
                            <div className="font-light mb-1 text-[#E1E4E5] mt-4">CO2</div>
                            <Dropdown 
                                type={'co2-unit'}
                                isShow={dropdownStates.co2Unit}
                                value={co2Unit}
                                valueArr={co2UnitArr}
                                handleClick={(val) => { handleClickDropdown('co2Unit', val) }}
                                handleValueClick={(val) => { setCo2Unit(val) }}
                            />
                            <div className="font-light mb-1 text-[#E1E4E5] mt-4">{t('admin.Preferences.Temperature')}</div>
                            <Dropdown 
                                type={'temp-unit'}
                                isShow={dropdownStates.tempUnit}
                                value={tempUnit}
                                valueArr={tempUnitArr}
                                handleClick={(val) => { handleClickDropdown('tempUnit', val) }}
                                handleValueClick={(val) => { setTempUnit(val) }}
                            />
                            <div className="font-light mb-1 text-[#E1E4E5] mt-4">Gas</div>
                            <Dropdown 
                                type={'gas-unit'}
                                isShow={dropdownStates.gasUnit}
                                value={gasUnit}
                                valueArr={gasUnitArr}
                                handleClick={(val) => { handleClickDropdown('gasUnit', val) }}
                                handleValueClick={(val) => { setGasUnit(val) }}
                            />
                        </div>
                        <div className="bg-[#323238] p-5 rounded-lg w-[240px] h-[202px] flex flex-col text-white">
                            <div className="text-[#CBCED1] mb-5" style={{ fontSize: 18 }}>{t('admin.Preferences.PatientInfo')}</div>
                            <div className="font-light mb-1 text-[#E1E4E5]">{t('admin.Preferences.Height')}</div>
                            <Dropdown 
                                type={'height-unit'}
                                isShow={dropdownStates.heightUnit}
                                value={heightUnit}
                                valueArr={heightUnitArr}
                                handleClick={(val) => { handleClickDropdown('heightUnit', val) }}
                                handleValueClick={(val) => { setHeightUnit(val) }}
                            />
                            <div className="font-light mb-1 text-[#E1E4E5] mt-4">{t('admin.Preferences.Weight')}</div>
                            <Dropdown 
                                type={'weight-unit'}
                                isShow={dropdownStates.weightUnit}
                                value={weightUnit}
                                valueArr={weightUnitArr}
                                handleClick={(val) => { handleClickDropdown('weightUnit', val) }}
                                handleValueClick={(val) => { setWeightUnit(val) }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Preference;